<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">计划信息</div>
      </div>
      <div>
        <span>采购计划单号：</span>
        <span>{{ purchasePlanData.bizNo }}</span>
      </div>
    </div>

    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :showIndex="false"
      :paginationFlag="false"
    >
      <template slot="percentage" slot-scope="scope">
        <div class="progress">
          <el-progress
            color="#c59429"
            :stroke-width="10"
            type="circle"
            :percentage="scope.data.percentage"
          ></el-progress>
        </div>
      </template>
    </TablePublic>

    <div class="title title-mb title-mt">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">采摘批次</div>
        <el-button
          v-if="type != 'update'"
          class="line-button"
          icon="el-icon-plus"
          @click="handleAddRow"
        >新增批次</el-button>
      </div>
    </div>
    <el-form :model="form" ref="pickForm" :rules="rules" label-width="80px">
      <TablePublic
        :colLists="colLists2"
        :tableData="form.reqList"
        :paginationFlag="false"
        :headerCellClassMethod="addStar"
        :nonMargin="true"
      >
        <template slot="plantationId" slot-scope="scope">
          <el-form-item
            :prop="'reqList.' + scope.index + '.plantationId'"
            :rules="rules.plantationId"
            :show-message="false"
          >
            <el-select
              v-model="scope.data.plantationId"
              filterable
              placeholder="请选择"
              @change="
                handleChange(
                  scope.data.plantationId,
                  scope.index,
                  'plantationId',
                  dropPlantationList,
                  'id',
                  'name'
                )
              "
            >
              <el-option
                v-for="item in dropPlantationList"
                :key="item.id"
                :label="item.bizNo+'-'+item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="cultivationMethodSpecAttrKey" slot-scope="scope">
          <el-form-item
            :prop="'reqList.' + scope.index + '.cultivationMethodSpecAttrKey'"
            :rules="rules.plantationId"
            :show-message="false"
          >
            <el-select
              v-model="scope.data.cultivationMethodSpecAttrKey"
              filterable
              placeholder="请选择"
              @change="
                handleChange(
                  scope.data.cultivationMethodSpecAttrKey,
                  scope.index,
                  'cultivationMethodSpecValueKey',
                  cultivationSpecList,
                  'cultivationMethodSpecAttrKey',
                  'cultivationMethodSpecValueKey'
                )
              "
            >
              <el-option
                v-for="item in scope.data.cultivationSpecList"
                :key="item.cultivationMethodSpecAttrKey"
                :label="item.cultivationMethodSpecValueKey"
                :value="item.cultivationMethodSpecAttrKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="cropAgeValue" slot-scope="scope">
          <el-form-item
            :prop="'reqList.' + scope.index + '.cropAgeValue'"
            :rules="rules.plantationId"
            :show-message="false"
          >
            <el-select v-model="scope.data.cropAgeValue" filterable placeholder="请选择">
              <el-option
                v-for="item in scope.data.cropAgeValues"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="ripenessLevelSpecAttrKey" slot-scope="scope">
          <el-form-item
            :prop="'reqList.' + scope.index + '.ripenessLevelSpecAttrKey'"
            :rules="rules.plantationId"
            :show-message="false"
          >
            <el-select
              v-model="scope.data.ripenessLevelSpecAttrKey"
              filterable
              placeholder="请选择"
              @change="
                handleChange(
                  scope.data.ripenessLevelSpecAttrKey,
                  scope.index,
                  'ripenessLevelSpecAttrValueKey',
                  scope.data.ripenessSpecList,
                  'dictValue',
                  'dictLabel'
                )
              "
            >
              <el-option
                v-for="item in scope.data.ripenessSpecList"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="planToPickTotalQuantity" slot-scope="scope">
          <el-form-item
            :prop="'reqList.' + scope.index + '.planToPickTotalQuantity'"
            :rules="rules.planToPickTotalQuantity"
            :show-message="false"
          >
            <el-input v-model="scope.data.planToPickTotalQuantity" placeholder="请输入"></el-input>
          </el-form-item>
        </template>
        <template slot="plannedNetWeightPerUnit" slot-scope="scope">
          <el-form-item
            :prop="'reqList.' + scope.index + '.plannedNetWeightPerUnit'"
            :rules="rules.plannedNetWeightPerUnit"
            :show-message="false"
          >
            <el-input v-model="scope.data.plannedNetWeightPerUnit" placeholder="请输入"></el-input>
          </el-form-item>
        </template>
        <template slot="planToPickTotalNetWeight" slot-scope="scope">
          <el-form-item
            :prop="'reqList.' + scope.index + '.planToPickTotalNetWeight'"
            :rules="rules.planToPickTotalNetWeight"
            :show-message="false"
          >
            <el-input
              v-model="scope.data.planToPickTotalNetWeight"
              placeholder="请输入"
              @input="(value)=>handleInput(value, scope.index, 'planToPickTotalNetWeight')"
            ></el-input>
          </el-form-item>
        </template>
        <template slot="unitPrice" slot-scope="scope">
          <el-form-item
            :prop="'reqList.' + scope.index + '.unitPrice'"
            :rules="rules.unitPrice"
            :show-message="false"
          >
            <el-input
              v-model="scope.data.unitPrice"
              placeholder="请输入"
              @input="(value)=>handleInput(value, scope.index, 'unitPrice')"
            ></el-input>
          </el-form-item>
        </template>
        <template slot="totalAmount" slot-scope="scope">
          <span>{{ scope.data.totalAmount }}</span>
        </template>
        <template slot="processFactoryId" slot-scope="scope">
          <el-form-item
            :prop="'reqList.' + scope.index + '.processFactoryId'"
            :rules="rules.processFactoryId"
            :show-message="false"
          >
            <el-select
              v-model="scope.data.processFactoryId"
              filterable
              placeholder="请选择"
              @change="
                handleChange(
                  scope.data.processFactoryId,
                  scope.index,
                  'processFactoryName',
                  dropFactoryList,
                  'id',
                  'name'
                )
              "
            >
              <el-option
                v-for="item in dropFactoryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="warehouseCode" slot-scope="scope">
          <el-form-item
            :prop="'reqList.' + scope.index + '.warehouseCode'"
            :rules="rules.warehouseCode"
            :show-message="false"
          >
            <el-select
              v-model="scope.data.warehouseCode"
              filterable
              placeholder="请选择"
              @change="
                handleChange(
                  scope.data.warehouseCode,
                  scope.index,
                  'warehouseName',
                  dropWarehouseList,
                  'bizCode',
                  'name'
                )
              "
            >
              <el-option
                v-for="item in dropWarehouseList"
                :key="item.bizCode"
                :label="item.name"
                :value="item.bizCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="storageAreaCode" slot-scope="scope">
          <el-form-item
            :prop="'reqList.' + scope.index + '.storageAreaCode'"
            :rules="rules.storageAreaCode"
            :show-message="false"
          >
            <el-select
              v-model="scope.data.storageAreaCode"
              filterable
              placeholder="请选择"
              @change="
                handleChange(
                  scope.data.storageAreaCode,
                  scope.index,
                  'storageArea',
                  scope.data.warehouseAreaList,
                  'bizCode',
                  'name'
                )
              "
            >
              <el-option
                v-for="item in scope.data.warehouseAreaList"
                :key="item.bizCode"
                :label="item.name"
                :value="item.bizCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="solts" slot-scope="scope">
          <el-button
            @click="handleDelRow(scope.data, scope.index)"
            type="text"
            size="small"
            class="delbutton"
          >删除</el-button>
        </template>
      </TablePublic>

      <div class="title title-mt title-mb" v-if="type == 'update'">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">修改原因</div>
          <el-popover placement="right-end" width="900" trigger="manual" v-model="visible">
            <div>
              <div class="popover_title">
                <div>修改记录</div>
                <div class="el-icon-circle-close" @click="visible = false"></div>
              </div>
              <TablePublic
                :colLists="colLists3"
                :showIndex="false"
                :tableData="tableData2"
                tableHeight="400"
                :paginationFlag="false"
              >
                <template slot="modificationDesc" slot-scope="scope">
                  <el-tooltip
                    :disabled="!scope.data.modificationDesc"
                    :content="scope.data.modificationDesc"
                    placement="top"
                    popper-class="custom-tooltip-width"
                  >
                    <div class="modificationDesc">{{ scope.data.modificationDesc }}</div>
                  </el-tooltip>
                </template>
              </TablePublic>
            </div>
            <el-button slot="reference" class="line-button" @click="visible = true">修改记录</el-button>
          </el-popover>
        </div>
      </div>
      <el-card class="box-card">
        <el-row :gutter="20" v-if="type == 'update'">
          <el-col :span="24" :xs="12">
            <el-form-item label="修改原因" prop="reason">
              <el-input
                :rows="3"
                resize="none"
                type="textarea"
                maxlength="300"
                v-model="form.reason"
                placeholder="300字以内"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <div class="btn-buttons">
        <el-button :disabled="loading" class="batch-button" @click="cancelPickFrom">取 消</el-button>
        <el-button :loading="loading" class="line-button" @click="submitPickFrom">确 定</el-button>
      </div>
    </el-form>
    <!-- <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="80%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component v-if="dialogVisible" :ref="currentView" :is="currentView"></component>
      <span slot="footer">
        <el-button :disabled="loading" class="batch-button" @click="cancel">取 消</el-button>
        <el-button :loading="loading" class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>-->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="80%"
      append-to-body
      :fullscreen="mFullscreen"
      :before-close="cancel"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :top="'0vh'"
      center
    >
      <div slot="title">
        <DialogHead :title="title" :mFullscreen.sync="mFullscreen" @cancel="cancel"></DialogHead>
      </div>
      <component v-if="dialogVisible" :ref="currentView" :is="currentView"></component>
      <span slot="footer">
        <el-button :disabled="loading" class="batch-button" @click="cancel">取 消</el-button>
        <el-button :loading="loading" class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/statusConstants'
import { mapState, mapActions } from 'vuex'
import {
  getDropFactoryList,
  delPickBatch,
  getPurchasePlanDetail,
  getDropPlantationList,
  addPickBatch,
  updatePickBatch,
  updatePickBatchList,
  getPickManageList,
  getPickBatchDetail,
  getAmdRecList,
} from '@/api/system/manage'
import { getWarehousePullDownList, getWarehouseAreaPullDownList } from '@/api/manage/warehouse'
import ManageDetail from '@/views/procure/proDetail/components/manageDetail'
import TablePublic from '@/components/tablePublic'
import Attachment from '@/components/attachment.vue'
import DialogHead from '@/components/innerDialogHead.vue'
export default {
  components: { TablePublic, Attachment, DialogHead, ManageDetail },
  data() {
    return {
      title: '',
      loading: false,
      dialogVisible: false,
      mFullscreen: false,
      pickDetail: {},
      form: {
        reqList: [],
      },
      rules: {
        plantationId: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        cultivationMethodSpecAttrKey: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        cropAgeValue: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        ripenessLevelSpecAttrKey: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        planToPickTotalNetWeight: [{ required: true, message: '请输入', trigger: 'blur' }],
        unitPrice: [{ required: true, message: '请输入', trigger: 'blur' }],
        reason: [{ required: true, message: '请输入', trigger: 'blur' }],
        processFactoryId: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],

        // plannedNetWeightPerUnit: [{ required: true, message: '请输入', trigger: 'blur' }],
        // warehouseCode: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        // storageAreaCode: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
      },
      list: [],
      ripenessSpecList: [],
      cultivationSpecList: [],
      currentView: '',
      colLists: [
        {
          prop: 'code',
          label: '',
          isTrue: true,
          children: [
            {
              prop: 'index',
              label: '序号',
              isTrue: true,
              width: '55',
            },
            {
              prop: 'cultivationMethodSpecValueKey',
              label: '培育方式',
              isTrue: true,
            },
            {
              prop: 'ripenessLevelSpecValueKey',
              label: '成熟度',
              isTrue: true,
            },
            {
              prop: 'planToPurchaseNetWeight',
              label: '计划采购总净重(斤)',
              isTrue: true,
            },
            {
              prop: 'purchasedNetWeight',
              label: '已计划采摘总净重(斤)',
              isTrue: true,
            },
            {
              prop: 'percentage',
              label: '已计划采摘进度',
              isTrue: true,
              formSolt: true,
            },
          ],
        },
      ],
      colLists2: [
        {
          prop: 'bizNo',
          label: '采摘批次',
          isTrue: true,
          width: '120',
        },
        {
          prop: 'plantationId',
          label: '果园编号',
          isTrue: true,
          formSolt: true,
          width: '118',
        },
        {
          prop: 'plantationName',
          label: '果园名称',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'locName',
          label: '果园区域',
          isTrue: true,
          width: '130',
        },
        {
          prop: 'cultivationMethodSpecAttrKey',
          label: '培育方式',
          isTrue: true,
          formSolt: true,
          width: '130',
        },
        {
          prop: 'cropAgeValue',
          label: '果树树龄(年)',
          isTrue: true,
          formSolt: true,
          width: '130',
        },
        {
          prop: 'ripenessLevelSpecAttrKey',
          label: '成熟度',
          isTrue: true,
          formSolt: true,
          width: '130',
        },
        {
          prop: 'planToPickTotalQuantity',
          label: '计划采摘总筐数',
          isTrue: true,
          formSolt: true,
          width: '150',
        },
        {
          prop: 'plannedNetWeightPerUnit',
          label: '计划单筐净重(斤)',
          isTrue: true,
          formSolt: true,
          width: '150',
        },
        {
          prop: 'planToPickTotalNetWeight',
          label: '计划采摘总净重(斤)',
          isTrue: true,
          formSolt: true,
          width: '160',
        },
        {
          prop: 'unitPrice',
          label: '单价(元)',
          isTrue: true,
          formSolt: true,
          width: '150',
        },
        {
          prop: 'totalAmount',
          label: '合计(元)',
          isTrue: true,
        },
        {
          prop: 'processFactoryId',
          label: '加工厂',
          isTrue: true,
          formSolt: true,
          width: '130',
        },
        {
          prop: 'warehouseCode',
          label: '仓库',
          isTrue: true,
          formSolt: true,
          width: '130',
        },
        {
          prop: 'storageAreaCode',
          label: '库区',
          isTrue: true,
          formSolt: true,
          width: '130',
        },
        {
          prop: 'fertilizerTypeKeyValue',
          label: '施肥种类',
          isTrue: true,
        },
        {
          prop: 'fieldTypeKeyValueList',
          label: '土地性质',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'ownerName',
          label: '园主/场长',
          isTrue: true,
          width: '110',
        },
        {
          prop: 'ownerContact',
          label: '联系方式',
          isTrue: true,
          width: '140',
        },

        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 50,
          rightFlag: true,
        },
      ],
      visible: false,
      colLists3: [
        {
          prop: 'modificationDesc',
          label: '修改内容',
          isTrue: true,
          formSolt: true,
          align: 'left',
        },
        {
          prop: 'reason',
          label: '修改原因',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'createDate',
          label: '修改日期',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'createBy',
          label: '修改人',
          isTrue: true,
          width: '100',
        },
      ],
      dropPlantationList: [],
      dropWarehouseList: [],
      dropFactoryList: [],
      tableData2: [],
      tableData: [],
      groupByCultivationMethodSpeces: [],
    }
  },
  computed: {
    ...mapState({
      purchasePlanData: (state) => state.manage.infoDetail || {},
      ripenessList: (state) => (state.system.dictList && state.system.dictList.ripenessLevel) || [],
      dictList: (state) => state.system.dictList || [],
    }),
  },
  created() {
    this.type = this.$route.query.type
    this.pickId = this.$route.query.id
    this.getDictList({
      types: 'ripenessLevel, cultivationMethod, fertilizerType, landStatus, productType',
      productName: '柑果',
    })
    this.getDropPlantations()
    this.getDropFactoryList()
    this.getDropWarehouses()
    this.getPlanDetail()
  },
  methods: {
    ...mapActions({ getDictList: 'system/getDictList' }),
    getDropWarehouses() {
      getWarehousePullDownList().then((res) => {
        if (res.flag) {
          this.dropWarehouseList = res.data
        }
      })
    },
    getWarehouseAreaPullDownList(index, value) {
      if (value) {
        getWarehouseAreaPullDownList({
          warehouseCode: value,
        }).then((res) => {
          if (res.flag) {
            this.$set(this.form.reqList[index], 'warehouseAreaList', res.data)
          }
        })
      }
    },
    getDropPlantations() {
      getDropPlantationList({
        readyForHarvestStatus: 1,
      }).then((res) => {
        if (res.flag) {
          this.dropPlantationList = res.data
        }
      })
    },
    getDropFactoryList() {
      getDropFactoryList({ type: 2 }).then((res) => {
        if (res.flag) {
          this.dropFactoryList = res.data
        }
      })
    },
    getPlanDetail() {
      getPurchasePlanDetail(this.purchasePlanData.id).then((res) => {
        if (res.flag) {
          this.colLists[0].label = res.data.name
          this.tableData = res.data.itemRespList.map((d, index) => {
            d.index = index + 1
            d.percentage = this.myFixed((d.purchasedNetWeight / d.planToPurchaseNetWeight) * 100, 2) || 0
            return d
          })

          this.groupByCultivationMethodSpeces = this.groupClassByKey(
            res.data.itemRespList,
            'cultivationMethodSpecValueKey'
          )

          this.cultivationSpecList = this.uniqueArr(res.data.itemRespList, 'cultivationMethodSpecAttrKey')
          this.$store.commit('manage/SET_INFO_DETAIL', res.data)

          if (this.type == 'update' && this.pickId) {
            this.colLists2.splice(-1)
            this.getPickDetail()
            this.getAmdRecList()
          }
        }
      })
    },
    getPickDetail() {
      getPickBatchDetail(this.pickId).then((res) => {
        if (res.flag) {
          this.pickDetail = res.data
          this.getPickManageDetails(
            0,
            res.data.plantationId,
            res.data.cultivationMethodSpecAttrKey,
            res.data.warehouseCode
          )
        }
      })
    },
    getAmdRecList() {
      getAmdRecList({ formId: this.pickId, formType: 'picking_batch' }).then((res) => {
        if (res.flag) {
          this.tableData2 = res.data.map((d) => {
            d.createDate = this.parseTime(d.createTime, '{y}-{m}-{d}')
            return d
          })
        }
      })
    },
    setCultivationSpecAndRipenessSpecList(data) {
      // console.log(this.groupByCultivationMethodSpeces,'this.groupByCultivationMethodSpeces')
      return data.map((d) => {
        let ripenessSpeces =
          this.groupByCultivationMethodSpeces.find((g) => d.cultivationMethodSpecValueKey == g.title).list || []
        let ripenessHasSpecesFlag = ripenessSpeces.some(
          (r) => r.ripenessLevelSpecAttrKey == '' || !r.ripenessLevelSpecAttrKey
        )
        if (ripenessHasSpecesFlag) {
          d.ripenessSpecList = this.ripenessList
        } else {
          let ripenessSpeceResult = []
          for (let i = 0; i < ripenessSpeces.length; i++) {
            const ripenessLevelSpecAttrKeys = ripenessSpeces[i].ripenessLevelSpecAttrKey.split(',')
            const ripenessLevelSpecValueKeys = ripenessSpeces[i].ripenessLevelSpecValueKey.split(',')
            for (let r = 0; r < ripenessLevelSpecValueKeys.length; r++) {
              ripenessSpeceResult.push({
                dictValue: ripenessLevelSpecAttrKeys[r],
                dictLabel: ripenessLevelSpecValueKeys[r],
              })
            }
          }
          d.ripenessSpecList = ripenessSpeceResult
        }
        let cultivationSpecs = []
        for (let i = 0; i < this.cultivationSpecList.length; i++) {
          for (let j in d.cultivationMethodSpecAttrKeys) {
            if (this.cultivationSpecList[i].cultivationMethodSpecAttrKey == d.cultivationMethodSpecAttrKeys[j]) {
              cultivationSpecs.push(this.cultivationSpecList[i])
            }
          }
        }
        d.cultivationSpecList = cultivationSpecs
        return d
      })
    },
    submitFrom() {
      this.loading = true
      this.$refs[this.currentView]
        .submit()
        .then(async (data) => {
          let result = await addPickBatch({
            purchasePlanId: this.purchasePlanData.id,
            reqList: data.map((d) => {
              delete d.id
              d.spec =
                (d.ripenessLevelSpecAttrValueKey || '无') +
                '-' +
                d.locDetails?.slice(d.locDetails?.lastIndexOf(',') + 1) +
                '-' +
                d.cultivationMethodSpecValueKey
              return d
            }),
          })
          this.loading = false
          if (result.code == 200 && result.flag) {
            const res = result.data.map((d, i) => {
              d.locName = this.formatLocal(d.locDetails, 3)
              d.cultivationMethodSpecAttrKeys = data[i].cultivationMethodSpecAttrKeys
              if (
                d.cultivationMethodSpecAttrKey == data[i].cultivationMethodSpecAttrKey &&
                d.plantationId == data[i].plantationId
              ) {
                d.cropAgeValues = data[i].cropAgeValues
              }
              return d
            })
            this.form.reqList.push(...this.setCultivationSpecAndRipenessSpecList(res))
            this.$message.success('提交成功')
            this.cancel()
          } else {
            this.$message.error(result.message)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleInput(value, index, fieldName) {
      if (fieldName == 'planToPickTotalNetWeight') {
        this.form.reqList[index].totalAmount = this.myFixed(value * this.form.reqList[index].unitPrice, 2)
      } else if (fieldName == 'unitPrice') {
        this.form.reqList[index].totalAmount = this.myFixed(
          value * this.form.reqList[index].planToPickTotalNetWeight,
          2
        )
      }
    },
    handleChange(value, index, fieldName, list, key, keyText) {
      this.form.reqList[index][fieldName] = list.find((item) => item[key] == value)[keyText]
      if (fieldName == 'plantationId' || fieldName == 'cultivationMethodSpecValueKey') {
        this.$refs.pickForm.clearValidate()
        this.form.reqList[index].unitPrice = ''
        this.form.reqList[index].totalAmount = ''
        // this.form.reqList[index].cropAgeValue = ''
        // this.form.reqList[index].cropAgeValues = ''
        this.form.reqList[index].planToPickTotalQuantity = ''
        this.form.reqList[index].plannedNetWeightPerUnit = ''
        this.form.reqList[index].planToPickTotalNetWeight = ''
        this.form.reqList[index].ripenessLevelSpecAttrKey = ''
        this.form.reqList[index].ripenessLevelSpecAttrValueKey = ''

        if (this.type == 'update') {
          delete this.pickDetail.unitPrice
          delete this.pickDetail.totalAmount
          delete this.pickDetail.planToPickTotalQuantity
          delete this.pickDetail.plannedNetWeightPerUnit
          delete this.pickDetail.planToPickTotalNetWeight
          delete this.pickDetail.ripenessLevelSpecAttrKey
          delete this.pickDetail.ripenessLevelSpecAttrValueKey
          delete this.pickDetail.cultivationMethodSpecAttrKey
          delete this.pickDetail.cultivationMethodSpecValueKey
          delete this.pickDetail.cropAgeValue
          delete this.pickDetail.cropAgeValues
        }

        if (fieldName == 'plantationId') {
          const cultivationMethodSpecAttrKey = this.cultivationSpecList[0].cultivationMethodSpecAttrKey
          const cultivationMethodSpecValueKey = this.cultivationSpecList[0].cultivationMethodSpecValueKey
          this.form.reqList[index].cultivationMethodSpecAttrKey = cultivationMethodSpecAttrKey
          this.form.reqList[index].cultivationMethodSpecValueKey = cultivationMethodSpecValueKey
          this.getPickManageDetails(index, value, cultivationMethodSpecAttrKey)
        }
        if (fieldName == 'cultivationMethodSpecValueKey') {
          this.getPickManageDetails(index, this.form.reqList[index].plantationId, value)
        }
      }
      if (fieldName == 'warehouseName') {
        this.form.reqList[index].storageArea = ''
        this.form.reqList[index].storageAreaCode = ''
        this.getWarehouseAreaPullDownList(index, value)
      }
    },
    getPickManageDetails(index, value, cultivationMethodSpecAttrKeys, warehouseCode) {
      getPickManageList({
        plantationId: value,
        cultivationMethodSpecAttrKeys,
      })
        .then((res) => {
          if (res.flag) {
            let row = res.data.items.map((d) => {
              delete d.id
              return {
                ...d,
                locName: this.formatLocal(d.locDetails, 3),
                cropBrandKeyValue: this.formatDictToText(d.cropBrandKey, 'productType', this.dictList),
                fieldTypeKeyValueList: this.formatDictToText(d.fieldTypeKeyList, 'landStatus', this.dictList),
                fertilizerTypeKeyValue: this.formatDictToText(d.fertilizerTypeKey, 'fertilizerType', this.dictList),
                pesticideTestResult: CONSTANTS.getStatusConversion(
                  d.pesticideTestPassedStatus,
                  'pesticideTestPassedStatus'
                ),
                heavyMetalTestResult: CONSTANTS.getStatusConversion(
                  d.heavyMetalTestPassedStatus,
                  'heavyMetalTestPassedStatus'
                ),
              }
            })
            if (this.type == 'save') {
              row = row.map((r) => {
                return {
                  ...r,
                  id: this.form.reqList[index].id,
                  bizNo: this.form.reqList[index].bizNo,
                  storageArea: '',
                  warehouseCode: '',
                  warehouseName: '',
                  storageAreaCode: '',
                  processFactoryId: '',
                  processFactoryName: '',
                }
              })
            }
            if (this.type == 'update') {
              row = row.map((r) => {
                delete r.cropAgeValue
                return {
                  ...this.pickDetail,
                  ...r,
                }
              })
            }
            this.form.reqList.splice(index, 1, this.setCultivationSpecAndRipenessSpecList(row)[0])
            this.getWarehouseAreaPullDownList(index, warehouseCode)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    cancelPickFrom() {
      if (this.type == 'save') {
        if (!this.form.reqList || !this.form.reqList.length) {
          this.$router.go(-1)
        } else {
          this.$confirm('确定取消吗？取消后将删除已经新增的采摘批次信息！', '提示', {
            confirmButtonClass: 'confirm_button',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              const ids = this.form.reqList.map((d) => d.id).join(',')
              delPickBatch(ids).then((response) => {
                if (response.code == 200 && response.flag) {
                  this.$router.go(-1)
                } else {
                  this.$message.warning(response.message)
                }
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除',
              })
            })
        }
      } else {
        this.$router.go(-1)
      }
    },
    async submitPickFrom() {
      this.$refs['pickForm'].validate(async (valid) => {
        if (valid) {
          if (!this.form.reqList.length) {
            this.$message.error('请新增至少一条采摘批次')
            return
          }
          let reg = /^([1-9][0-9]*)+(\.[0-9]{1,6})?$/
          let numFlag = this.form.reqList.some((d) => {
            if (
              (d.plannedNetWeightPerUnit && !reg.test(d.plannedNetWeightPerUnit)) ||
              (d.planToPickTotalQuantity && !reg.test(d.planToPickTotalQuantity)) ||
              !reg.test(d.planToPickTotalNetWeight) ||
              !reg.test(d.unitPrice)
            ) {
              return true
            }
          })
          if (numFlag) {
            this.$message.error('采摘批次中数量只能为正整数或小数，请检查！')
            return
          }
          this.loading = true
          let result = null
          if (this.type == 'save') {
            result = await updatePickBatchList({
              purchasePlanId: this.purchasePlanData.id,
              reqList: this.form.reqList.map((d) => {
                d.spec =
                  (d.ripenessLevelSpecAttrValueKey || '无') +
                  '-' +
                  d.locDetails?.slice(d.locDetails?.lastIndexOf(',') + 1) +
                  '-' +
                  d.cultivationMethodSpecValueKey
                return d
              }),
            })
          }
          if (this.type == 'update') {
            const row = this.form.reqList.map((d) => {
              d.spec =
                (d.ripenessLevelSpecAttrValueKey || '无') +
                '-' +
                d.locDetails?.slice(d.locDetails?.lastIndexOf(',') + 1) +
                '-' +
                d.cultivationMethodSpecValueKey
              return d
            })[0]
            const data = { ...row, reason: this.form.reason }
            result = await updatePickBatch(data)
          }
          this.loading = false
          if (result.code == 200 && result.flag) {
            this.$message.success('提交成功')
            this.$router.go(-1)
          } else {
            this.$message.error(result.message)
          }
        } else {
          this.loading = false
        }
      })
    },
    cancel() {
      if (this.loading) {
        return
      }
      // this.$refs[this.currentView].reset()
      this.dialogVisible = false
    },
    handleAddRow() {
      this.title = '选择果园'
      this.currentView = 'manageDetail'
      this.dialogVisible = true
    },
    handleDelRow(row, index) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delPickBatch(row.id).then((response) => {
            if (response.code == 200 && response.flag) {
              this.form.reqList.splice(index, 1)
              this.$message.success(`删除成功！`)
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    addStar(obj) {
      if (
        obj.columnIndex === 2 ||
        obj.columnIndex === 5 ||
        obj.columnIndex === 6 ||
        obj.columnIndex === 7 ||
        obj.columnIndex === 10 ||
        obj.columnIndex === 11 ||
        obj.columnIndex === 13
        //  ||
        // obj.columnIndex === 14 ||
        // obj.columnIndex === 15
      ) {
        return 'star'
      }
    },
    seeHistory() {
      this.dialogVisible = true
    },
    addfile() {},
    handleDelFile() {},
    remoteMethod() {},
  },
}
</script>

<style scoped lang='less'>
@import '../../../assets/form.less';
/deep/ .delbutton.el-button--text {
  color: red;
}
.progress {
  height: 48px;
  display: flex;
  justify-content: center;
}
/deep/ .el-progress-circle {
  width: 48px !important;
  height: 48px !important;
}
/deep/ .el-progress__text {
  font-size: 12px !important;
}
.progress {
  margin-bottom: 0px;
  padding-bottom: 0px;
}
/deep/ .line-button {
  background-color: #c59429;
  color: #ffffff;
  border-color: #c59429;
  margin-left: 20px;
}
.btn-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
/deep/ .el-card__body,
.el-main {
  padding: 20px 20px 0;
}
::v-deep {
  .el-dialog {
    margin-bottom: 0;
    border-radius: 16px;
  }
  .el-dialog__body {
    max-height: calc(100vh - 180px);
    overflow: auto;
  }
}
</style>